import { useMemo } from 'react';
import { useFinance } from '@/hooks/useFinance';
import { useFinanceAlertWatch } from '@/hooks/useFinanceAlertWatch';
import { buildFinanceAlerts } from '@/lib/financeAlerts';

/**
 * Guetteur invisible : dès qu'une alerte financière ACTIVÉE apparaît,
 * elle est poussée dans la cloche et en notification PWA.
 * Monté au niveau du module Finance pour couvrir toutes ses pages.
 */
export default function FinanceAlertWatcher() {
  const finance = useFinance();
  const { currency, loading, error, expenses, accountBalances } = finance;

  const alerts = useMemo(
    () =>
      buildFinanceAlerts(
        {
          invoices: finance.invoices,
          suppliers: finance.suppliers,
          supplierTransactions: finance.supplierTransactions,
          recurring: finance.recurring,
          accountBalances,
          credit: finance.credit
            ? { customers: finance.credit.customers, balances: finance.credit.balances }
            : null,
          expenses,
          supplierBalance: finance.supplierBalance,
          alertPrefs: finance.alertPrefs,
        },
        currency,
      ),
    [finance, expenses, currency, accountBalances],
  );

  useFinanceAlertWatch(finance.merchantId, alerts, !loading && !error);
  return null;
}